module.exports = __webpack_public_path__ + "static/media/photo6.1f59f908.png";